export const questions = [
    {
        key: 0,
        title: `Just type the name of the event`,
        body: ``,
        solution: "05e2635fcedb1d2edd4cadeff45a39c3e987d6fbdaf79f518927725509aeec30",
    },
    {
        key: 'b8183e09a70b80671bf0e36242d8000065f02661283af068ca6068a3e31ea71a',
        title: `The place where we all meet for fun Fridays`,
        body: ``,
        solution: "e6f7f04f5a43e53f4df979478918ca1c962f1b93b9b5cce6690290d1748780ff",
    },
    {
        key: 'c7faf4aeb223e2080115bc188a10da218ce87ead127802ed41942b0f721b6e2b',
        title: `A letter(english), that charges up electronics`,
        body: ``,
        solution: "2e7d2c03a9507ae265ecf5b5356885a53393a2029d241394997265a1a25aefc6",
    },
    {
        key: 'c8623e984cf78e0f3a959827b540a5cdbe4da246f5302ec8de4270300cf724c1',
        title: `Everyone wants to go here for the office trip`,
        body: ``,
        solution: "c0a46612b21b1d9ea3c212a9c8b40a90b7aa629dc36ab8f36cd9f31e40bc9ed6",
    },
    {
        key: 'cf6f6adf208a7adce3c7f462bfa47b33998d2e1669c692cc512209cda1fe626a',
        title: `Why did a power lifter name his left arm ‘Neil’ and right arm ‘Lance’ ?`,
        body: ``,
        solution: "7ff26ca7636fecde95757c88c79117cd5733344dce935994ba0683bd8ae30471",
    },
    {
        key: '9fd4c9e7c4af55e55c59aeaf4e92b79bbb6154b1079708a43a8af31f0c93cf0e',
        title: `These 2 people completed their 1 year anniversary at Grid recently (comma separated X, Y)`,
        body: ``,
        solution: "f6221e107830013d0cad44fe312a62aa1c4b37f06d6a7a6688a81500b2bb069d",
    },
    {
        key: 'dd88b5c845d8404a60a774291a064409f79173751d10f5bf7276e6e54a58bce2',
        title: `Something that turns the lights in your room on, but turns off the HR when you ________`,
        body: ``,
        solution: "78b49fb2cc2d2ed6c1bb8383b3d267b3bc623a8a0fb4aff4aa5d3db74c3b4967",
    },
    {
        key: '7011115572d9c98796f1239c4aee9c545519c8170a57ece7c38dfdf4cdb2504d',
        title: `Smallest part of the screen you’re looking at, as well as a popular smartphone.`,
        body: ``,
        solution: "3f8d7379e2f0f7d0c845a06f7b67ef80cacce0c686254aced769c1698f3fe59a",
    },
    {
        key: '0bb81e683a96a83e8a5a52165b9888c2c0266c224a54fbb1fef8d612ab70b66a',
        title: `Draw your best impression of Udit as a caricature (send it to the random channel when done. You’ll get the key to the next question then)`,
        body: ``,
        solution: "fd9eb97eeac849326b80c77ac3f03af408ac39ab36bf29afba08080d7d16ac63",
    },
    {
        key: '48db81d017750c615e1650f4b0e1a65c8d227890ae392ec666c77f0756eaa918',
        title: `Pursuit of ___________?`,
        body: ``,
        solution: "82c987f63bfe71d6a0388aae9860e19ac7c16a8e4d9bddb25d17e07343f65383",
    },
    {
        key: '289dc21f68a921c6668bd9de756c24bf6ecde4e1bbb4a1ffd83412bfa5be8f4b',
        title: `If A is 1, B is 2 …. Z is 26. What is the sum (in words) if we add up the 4 letters of our company name`,
        body: ``,
        solution: "ee72d16553a68259323733d6076682ae5a5745dd3e874467ddb5c6fff33b3a77",
    },
    {
        key: '172e293aeeed523e0a68c14bc048d5b20353f1e805f3c5df90cf336f1295f4d4',
        title: `share this public service announcement on slack `,
        body: `https://imgflip.com/i/7mc7d1`,
        solution: "d2a471c4066d3cf673cb908c8bdf1b9d6b9ec759d36a7dcaa6e595053ec2777f",
    },
    {
        key: 'c792ab2d3ede27e4f0b2f24d7a1c796631e296224a4c75c66fb3316517f69618',
        title: `Who is this?`,
        body: `https://img.freepik.com/free-photo/textured-background-white-tone_53876-128610.jpg`,
        solution: "b01eb7800731fed41e24b95965ce78cac74f2683eb298aaf57c5a278b21cdd58",
    },
    {
        key: 'bfffa8cfae87ef99b4ed38941ee70eaa57b7f80442cdd1d29a3567cbe8449e5e',
        title: `The answer to this question is what happened to you when you visited this link.`,
        body: `https://www.youtube.com/watch?v=dQw4w9WgXcQ`,
        solution: "c0bb0851a838990e6bfd55755dd8bcbfe15f8e2ea65ee0e8af6328a7018c532d",
    },
    {
        key: 'dde594903713b92490c93924fcbee87cc6f043d73be098e9b6fbb932ba78d5d3',
        title: `sing the first 2 lines from the song you just heard (do it on the meet)`,
        body: ``,
        solution: "d579482fe1813625906205f76e5bbcf8c83cbcff92de792c9c30ea984a8e879e",
    },
    {
        key: '9ada67d8d688be7a6c70cd536414284a85d8b3f299a59ce03824f4ab4038ca54',
        title: `I am a vehicle that travels very fast, I bring you news from the past. And even if you’re riding along with me, you appear to be going slower than all. How fast am I going in m/s. (Be precise)`,
        body: ``,
        solution: "efbf700e870cb889052cffbe9d66458a3145d88424df9582ae6da734b3fdd3ec",
    },
    {
        key: '37627ea363ffc69842b682e61afc95fade8f9cbc4098d0f0aad3f5d1541cc9f5',
        title: `Someone from the office is a source of the vehicle we were talking about in the previous question. Guess the person.`,
        body: ``,
        solution: "babde48edd97b6cabd4a378d655c9d023b28bc2ec7880b5a3e69ab3f27e3a028",
    },
    {
        key: '129a9a650513999c776f1e1f157dce510ad4428498454efa3861be80a4e082ee',
        title: `Someone from the office has the power to block the person in the previous question. Name the person`,
        body: ``,
        solution: "f1890d34155e35345158300aeb440e0d63ac883e5ea1c6fa8c564313acf781c9",
    },
    {
        key: 'c2747b480bda3c5129e7383290195736b963cbf34f6082745b2e53f0adaaa7b2',
        title: `caption this picture on slack for good luck`,
        body: `https://imgur.com/XtbUj46`,
        solution: "249c31f34648311e38d812d154e852f36035fdbe103a30c1684500d4d24185b9",
    },
    {
        key: '8707b529c31e5b36d989bbd0ed48c051187fd82887996b93869a77d05fffc094',
        title: `Da vinci’s muse`,
        body: ``,
        solution: "5a3e3fc66fc2c41debf712998defd85eb7e7851cb1ffb8033608882f45f64525",
    },
    {
        key: '4def088446633e6cdb0632e668cfceb4f7f7e71ae9589c224f2441e6de4141b5',
        title: `Three special letters on the first page you see as a stranger on app.workongrid.com`,
        body: ``,
        solution: "43bedf2a1d0b6ca79775b57b68b381f68b47913bd5f2c64184f834ade7f1898d",
    },
    {
        key: '67bb5a64f4bacf2b9dc5c0f645623008cb30c45c1e1fb874c5122fe20526bc7f',
        title: `The 2 last words you say when you leave`,
        body: ``,
        solution: "80b8497eb3580263b5cba90d4893ce97ed8ff42f4605e4065cdd04ed1106f763",
    },
]
export const finalHash = "01d797d9d877d529d279559596caaa13e8896e7444f28c695842cb034eb22034"